
import { useAuth } from '@/contexts/AuthContext';

type UserRole = 'admin' | 'coordinator' | 'customer';

export const useRoleAccess = () => {
  const { userRole, hasRole } = useAuth();

  const isAdmin = () => hasRole('admin');
  const isCoordinator = () => hasRole('coordinator');
  const isCustomer = () => hasRole('customer');
  
  const canAccessOperations = () => isAdmin() || isCoordinator();
  const canManageUsers = () => isAdmin();
  const canViewReports = () => isAdmin() || isCoordinator();
  const canAccessInternalPages = () => isAdmin() || isCoordinator();
  
  return {
    userRole,
    isAdmin,
    isCoordinator,
    isCustomer,
    canAccessOperations,
    canManageUsers,
    canViewReports,
    canAccessInternalPages,
    hasRole,
  };
};
